<template>
  <div class="width100">
    <div class="width98 margin-auto backwhite">
      <div class="width98 margin-auto pad-bot20 pad-top20">
        <p class="abstract pad-left10 dimensional">项目详情</p>
        <table class="width100 text-ellipsis margin-top20">
          <tr>
            <td class="tdtit">项目名称</td>
            <td class="tdcont">{{ form.title }}</td>
            <td class="tdtit">项目编号</td>
            <td class="tdcont">{{ form.project_number }}</td>
          </tr>
          <tr>
            <td class="tdtit">行业大类</td>
            <td class="tdcont">{{ form.industry_text }}</td>
            <td class="tdtit">行业小类</td>
            <td class="tdcont">{{ form.industry_small_text }}</td>
          </tr>
          <tr>
            <td class="tdtit">研发阶段</td>
            <td class="tdcont">
              {{ form.progress == 1 ? "研究阶段" : "开发阶段" }}
            </td>
            <td class="tdtit">技术关键词</td>
            <td class="tdcont">{{ form.keyword }}</td>
          </tr>
        </table>
        <div class="pad-top20">
          <p class="abstract pad-left10 dimensional">项目实施</p>
          <table class="width100 text-ellipsis margin-top20">
            <tr>
              <td class="tdtit">负 责 人</td>
              <td class="tdcont">{{ forms.nature }}</td>
              <td class="tdtit">承担部门</td>
              <td class="tdcont">{{ forms.name }}</td>
            </tr>
            <tr>
              <td class="tdtit">协作单位</td>
              <td class="tdcont">{{ forms.numbers }}</td>
              <td class="tdtit">立项时间</td>
              <td class="tdcont">{{ forms.date }}</td>
            </tr>
            <tr>
              <td class="tdtit">批准时间</td>
              <td class="tdcont" style="color: #f96d68">
                <span v-if="approval_time == null">{{ approval }}</span>
                <span v-if="approval_time != null"> {{ approval_time }}</span>
              </td>
              <td class="tdtit">结题时间</td>
              <td class="tdcont" style="color: #f96d68">
                <span v-if="finish_time == null">{{ finishte }}</span>
                <span v-if="finish_time != null"> {{ finish_time }}</span>
              </td>
            </tr>
          </table>
          <table class="width100 text-ellipsis">
            <tr>
              <td class="tdtit" style="border-top: none">项目备注</td>
              <td class="tdconts" style="border-top: none">{{ forms.desc }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <!-- 错误信息 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Projectdetail } from "@/api/Center/Center.api";
import { Base64 } from "js-base64";

import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisibleinitreport: false,
      dialogVisibleclosreport: false,
      authority_text: "",
      approval: "",
      finishte: "",
      centerNums: "",
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },

      Apisrc: "",
      head: {
        token: window.sessionStorage.getItem("token"),
      },
      textarea: "",
      summary: "",
      projectapproval: ["1"],
      Contentobjectives: ["1"],
      Methodtechnicalroute: ["1"],
      Existingfoundation: ["1"],
      projectsummary: ["1"],

      form: {
        title: "",
        progress: "",
        project_number: "",
        industry_small_text: "",
        industry_text: "",
        keyword: "",
      },

      approval_time: "",
      finish_status: "",
      finish_time: "",
      rduser: [],
      forms: {
        name: "",
        numbers: "",
        date: "",
        nature: "",
        desc: "",
      },
    };
  },
  components: {},
  methods: {},
  created() {
    this.centerNums = window.sessionStorage.getItem("centerNums");
    this.authority_text = window.sessionStorage.getItem("authority_text");
    Projectdetail({
      id: window.sessionStorage.getItem("sciprodetaliyid"),
    }).then((res) => {
      if (res.data.code == 200) {
        this.form.title = res.data.data.title;
        this.finish_status = res.data.data.finish_status;
        this.form.project_number = res.data.data.project_number;
        this.form.keyword = res.data.data.keyword;
        this.form.industry_small_text = res.data.data.industry_small_text;
        this.form.industry_text = res.data.data.industry_text;
        this.form.progress = res.data.data.progress;
        this.forms.date = res.data.data.start_date;
        this.forms.name = res.data.data.research_dev_title;
        this.forms.numbers = res.data.data.cooperation;
        this.forms.nature = res.data.data.manager_name;
        this.forms.desc = res.data.data.remark;
        this.approval = res.data.data.approval_text;
        this.approval_time = res.data.data.approval_time;
        this.finish_time = res.data.data.finish_time;
        this.finishte = res.data.data.finish_text;
        this.rduser = res.data.data.rduser;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    BUS.$on("sciprodetaliyid", (data) => {
      console.log(data);
      //    获取详情
      Projectdetail({ id: data }).then((res) => {
        if (res.data.code == 200) {
          this.form.title = res.data.data.title;
          this.finish_status = res.data.data.finish_status;
          this.form.project_number = res.data.data.project_number;
          this.form.keyword = res.data.data.keyword;
          this.form.industry_small_text = res.data.data.industry_small_text;
          this.form.industry_text = res.data.data.industry_text;
          this.form.progress = res.data.data.progress;
          this.forms.date = res.data.data.start_date;
          this.forms.name = res.data.data.research_dev_title;
          this.forms.numbers = res.data.data.cooperation;
          this.forms.nature = res.data.data.manager_name;
          this.forms.desc = res.data.data.remark;
          this.approval = res.data.data.approval_text;
          this.approval_time = res.data.data.approval_time;
          this.finish_time = res.data.data.finish_time;
          this.finishte = res.data.data.finish_text;
          this.rduser = res.data.data.rduser;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    });
  },
};
</script>
<style scoped>
.rediogree {
  display: inline-block;
  width: 6px;
  height: 6px;
  background: #e7e9ef;
  border-radius: 50%;
  position: relative;
  bottom: 2px;
  right: 2px;
}
.abstract {
  border-left: 4px solid #52c5cb;
  height: 20px;
  line-height: 20px;
}
table {
  border-collapse: collapse;
}
tr {
  width: 100%;
}
td {
  border: 1px solid #f0f0f0;
}
.tdtit {
  width: 15%;
  height: 40px;
  line-height: 40px;
  background: #f1f3f9;
  border: 1px solid rgba(233, 233, 233, 1);
  padding-left: 10px;
  font-size: 14px;
  color: #6a7589;
}
.tdcont {
  width: 35%;
  padding-left: 10px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #353a44;
}
.tdconts {
  width: 85%;
  padding-left: 10px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #353a44;
}
.approvebtn {
  display: inline-block;
  width: 80px;
  height: 26px;
  line-height: 26px;
  border-radius: 4px;
  background-color: rgba(58, 126, 230, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  margin: 5px 0 0 5px;
}
.approvebtns {
  display: inline-block;
  width: 80px;
  height: 26px;
  line-height: 26px;
  border-radius: 4px;
  background-color: rgba(58, 126, 230, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  margin: 5px 0 0 0;
}
.removebtn {
  display: inline-block;
  width: 12px;
  height: 12px;
  color: #fff;
  background: #969eac;
  border-radius: 50%;
  position: relative;
  top: 3px;
}
.el-icon-close {
  font-size: 12px !important;
  position: absolute;
}
.filebtnbg {
  background: #f6f7fb;
  margin-bottom: 10px;
  padding: 3px 10px;
}
.acceptancecomments {
  text-indent: 20px;
  text-align: left;
  width: 70%;
  line-height: 30px;
  padding-left: 10px;
  background-color: rgba(239, 242, 181, 1);
  border: 1px solid rgba(187, 187, 187, 1);
}
.itemconten >>> .el-form-item__content {
  text-align: left;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>